import React from "react";
import { connect } from "react-redux";
import language from "../../../language";
import { withRouter } from "../../../utils/withRouter";
import { getStorage } from "../../../utils/storage";
import MyRequests from "../../../components/Requests/MyRequests";
import { DashboardHeader } from "../../../components/Header";
import { Modal } from "../../../components/Modal";
import NominativeRequest from "../../../components/Requests/nominative/NominativeRequest";
import RequestTypeChooser from "../../../components/Requests/nominative/RequestTypeChooser";
import EmergencyAccountability from "../../../components/Requests/nominative/EmergencyAccountability";
import BulkRequest from "../../../components/Requests/bulk/BulkRequest";
import requestQuery from "../../../utils/queries/requestQuery";
import { Button } from "../../../components/Button";
import { defineRole } from "../../../utils/handleAccessRoles";
import {
  ROLE_NOMINATIVE_REQUEST,
  ROLE_BULK_REQUEST,
} from "../../../constants/ROLES";
import { Tabs } from "../../../components/Tabs";
import SearchRequest from "../../../components/Requests/SearchRequest";

class RequestManagementScreen extends React.Component {
  state = {
    user: {},
    data: [],
    type: "bulk",
    // Which kind of request is being raised. Asked first, because it
    // decides what the form asks next: an emergency release takes the
    // doctor's accountability in place of the patient's consent.
    requestType: null,
  };

  componentDidMount = async () => {
    const user = await getStorage();

    this.setState({ user });
  };

  handleShowModal(modal, modalTitle, selected_data = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selected_data,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  getData = async (isLoading, search = {}) => {
    try {
      const { defaultLanguage } = this.props;

      this.setState({ isLoading });

      const { data, totalRecords } = await requestQuery(
        defaultLanguage,
        await this.returnFilters(search),
      );

      this.setState({
        data: data,
        totalPageCount: totalRecords,
        isLoading: false,
      });
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  handleCheck(type, value) {
    this.setState({ [type]: value });
  }

  onChooseRequestType = (requestType) => {
    this.setState({ requestType, showRequestTypeChooser: false });

    if (requestType === "isEmergencyRelease") {
      this.setState({ showEmergencyAccountability: true });
      return;
    }

    this.setState({ showNominativeModal: true });
  };

  // Declining creates nothing at all: no request, no draft, no record that
  // one was started. The doctor is simply back where they were.
  onDeclineAccountability = () => {
    this.setState({
      showEmergencyAccountability: false,
      requestType: null,
    });
  };

  onAgreeAccountability = () => {
    this.setState({
      showEmergencyAccountability: false,
      showNominativeModal: true,
    });
  };

  render() {
    const canBulkRequest = defineRole({
      roles: this.state.user.accessRole,
      menu: ROLE_BULK_REQUEST,
      operation: "create",
    });
    const canNominativeRequest = defineRole({
      roles: this.state.user.accessRole,
      menu: ROLE_NOMINATIVE_REQUEST,
      operation: "create",
    });

    const canReadBulkRequest = defineRole({
      roles: this.state.user.accessRole,
      menu: ROLE_BULK_REQUEST,
      operation: "read",
    });
    const canReadNominativeRequest = defineRole({
      roles: this.state.user.accessRole,
      menu: ROLE_NOMINATIVE_REQUEST,
      operation: "read",
    });

    return (
      <>
        <div className="card-dashboard-content">
          <div className="card-body">
            {this.state.user.hospital &&
              (canBulkRequest || canNominativeRequest) && (
                <>
                  <div className="d-flex gap-2 mt-2">
                    {canBulkRequest && (
                      <Button
                        text={language[this.props.defaultLanguage].bulk_request}
                        className="btn btn-primary"
                        onPress={() => this.handleShowModal("showBulkRequest")}
                      />
                    )}

                    {canNominativeRequest && (
                      <Button
                        text={
                          language[this.props.defaultLanguage]
                            .nominative_request
                        }
                        className=" btn-transparent btn-bordered primary"
                        onPress={() =>
                          this.handleShowModal("showRequestTypeChooser")
                        }
                      />
                    )}
                  </div>
                  <hr />
                </>
              )}

            <div>
              <DashboardHeader
                title={language[this.props.defaultLanguage].requests}
              />
            </div>
            <>
              <Tabs
                // Lets a request page send the user back to the tab they came
                // from, e.g. /dashboard/requests?tab=nominative%20requests
                activeTab={
                  this.props.searchParams?.get("tab")?.toLowerCase() ||
                  undefined
                }
                options={[
                  // {
                  //   title: language[this.props.defaultLanguage].dashboard,
                  //   data: <RequestDashboard />,
                  // },
                  {
                    title: language[this.props.defaultLanguage].search,
                    data: <SearchRequest />,
                  },
                  canReadBulkRequest && {
                    title: language[this.props.defaultLanguage].bulk_requests,
                    data: <MyRequests showAdd type="bulk" />,
                  },
                  canReadNominativeRequest && {
                    title:
                      language[this.props.defaultLanguage].nominative_requests,
                    data: <MyRequests showAdd type="nominative" />,
                  },
                ].filter(Boolean)}
              />
              {/* <GuideFloatButton
              title="How to create a norminative request?"
              videoUrl="https://drive.google.com/file/d/1HUtXRxyestPy5urkABL9oZWN-LApjF3W/view?usp=sharing"
            /> */}
            </>
          </div>
        </div>

        <Modal
          handleClose={this.handleCloseModal.bind(
            this,
            "showRequestTypeChooser"
          )}
          show={this.state.showRequestTypeChooser}
          title={language[this.props.defaultLanguage].request_type}
          showHeaderBottomBorder={false}
        >
          <RequestTypeChooser
            onChoose={this.onChooseRequestType}
            onCancel={this.handleCloseModal.bind(
              this,
              "showRequestTypeChooser"
            )}
          />
        </Modal>

        <Modal
          handleClose={this.onDeclineAccountability}
          show={this.state.showEmergencyAccountability}
          title={
            language[this.props.defaultLanguage].physician_authorization
          }
          showHeaderBottomBorder={false}
        >
          <EmergencyAccountability
            onAgree={this.onAgreeAccountability}
            onDecline={this.onDeclineAccountability}
          />
        </Modal>

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showNominativeModal")}
          show={this.state.showNominativeModal}
          title={
            this.state.requestType === "isEmergencyRelease"
              ? language[this.props.defaultLanguage].emergency_release
              : language[this.props.defaultLanguage].nominative_request
          }
          showHeaderBottomBorder={false}
          size="lg"
        >
          <div>
            <NominativeRequest
              getData={this.getData.bind(this)}
              requestType={this.state.requestType}
              handleCloseModal={this.handleCloseModal.bind(
                this,
                "showNominativeModal"
              )}
              {...this.state.selected_data}
            />
          </div>
        </Modal>

        <Modal
          handleClose={() => this.handleCloseModal("showBulkRequest")}
          show={this.state.showBulkRequest}
          title={language[this.props.defaultLanguage].bulk_request}
          showHeaderBottomBorder={false}
          size="lg"
        >
          <div>
            <BulkRequest
              getData={this.getData.bind(this)}
              handleCloseModal={this.handleCloseModal.bind(
                this,
                "showBulkRequest"
              )}
              {...this.state.selected_data}
            />
          </div>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(withRouter(RequestManagementScreen));
